import { Box, ITheme, useTheme } from "@mui/material";
import React from "react";

export interface IContentBoxProps {
    proportion: number;
    children?: React.ReactNode;
}

const ContentBox: React.FC<IContentBoxProps> = ({ proportion, children }) => {
    const theme = useTheme() as ITheme;
    return <Box bgcolor={theme.palette.common.white} borderRadius={"8px"} padding={"22px 32px"} flexBasis={"100px"} flexGrow={proportion}>
        {children}
    </Box>
}

export default ContentBox;